import { render, staticRenderFns } from "./LoginDefaultForm.vue?vue&type=template&id=cdf36ece&scoped=true&"
import script from "./LoginDefaultForm.vue?vue&type=script&lang=js&"
export * from "./LoginDefaultForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginDefaultForm.vue?vue&type=style&index=0&id=cdf36ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf36ece",
  null
  
)

export default component.exports